import { forwardRef, type Ref, type SVGProps } from "react";
const IconColorPickerFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M22.777 4.503a1 1 0 0 1 1.338-.07l.077.069 3.3 3.3.069.075c.32.392.297.972-.069 1.339l-2.066 2.069 1.537 1.537.064.078a.5.5 0 0 1-.064.63l-.707.706-.078.065a.5.5 0 0 1-.551 0l-.078-.065-1.536-1.536-13.04 13.063c-.133.132-.3.226-.484.268l-4.288.988-.134.023a1.002 1.002 0 0 1-1.087-1.088l.022-.134.99-4.289q.047-.207.175-.377l.09-.104L19.3 7.986l-1.53-1.528-.065-.078a.5.5 0 0 1 .065-.63l.707-.706a.5.5 0 0 1 .628-.065l.079.065L20.71 6.57zM14.123 16h3.769l4.706-4.714L20.713 9.4z" />
  </svg>
);
const ForwardRef = forwardRef(IconColorPickerFilledSVG);
ForwardRef.displayName = "IconColorPickerFilled";
export { ForwardRef as IconColorPickerFilled };
